import * as t from "io-ts";

export const LocationBreadcrumbCodec = t.intersection([
  t.type({
    latitude: t.number,
    longitude: t.number,
    dttm: t.number,
  }),
  t.partial({
    accuracy: t.number,
    speed: t.number,
    speedAccuracy: t.number,
    bearing: t.number,
    bearingAccuracy: t.number,
  }),
]);

export const LocationBreadcrumbArrayCodec = t.array(
  LocationBreadcrumbCodec
);

export type LocationBreadcrumb = t.TypeOf<typeof LocationBreadcrumbCodec>;
